import { Button, IconButton, Typography } from '@mui/material';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import type { FC } from 'react';

export const PartnershipTagBadge: FC<{ tag: string }> = ({ tag }) => (
  <Button
    size="small"
    variant="contained"
    color="infoFill"
    disableRipple
    disableElevation
    disableFocusRipple
    disableTouchRipple
    sx={{
      '&': {
        display: 'flex',
        gap: 1 / 2,
        alignItems: 'center',
        whiteSpace: 'nowrap',
        textTransform: 'initial',
        pl: 1,
        minWidth: 20,
        maxWidth: 320,
        width: 'fit-content',
        justifyContent: 'flex-start',
        cursor: 'default',
      },
    }}
  >
    <LocalOfferIcon
      sx={(t) => ({
        fontSize: t.typography.h4.fontSize,
        color: t.palette.text.secondary,
      })}
    />
    <Typography
      variant="body2"
      component="span"
      sx={{
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        display: 'block',
        overflow: 'hidden',
      }}
    >
      Tag: <Typography variant="body2" component={'span'} fontWeight={600}>{tag ?? '-'}</Typography>
    </Typography>
  </Button>
);

interface RemovePartnershipButtonProps {
  canRemove: boolean;
  onRemove: () => void;
}

export const RemovePartnershipButton: FC<RemovePartnershipButtonProps> = ({
  canRemove,
  onRemove,
}) => (
  <IconButton
    className="remove-partnership-button"
    size="small"
    color="inherit"
    disabled={!canRemove}
    onClick={onRemove}
    aria-label="Remove partnership"
  >
    <DeleteOutlineIcon sx={{ fontSize: 18 }} />
  </IconButton>
);
